"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _util = _interopRequireDefault(require("util"));
var _uuid = _interopRequireDefault(require("uuid"));
var _window = _interopRequireDefault(require("global/window"));
var _ipAnonymize = _interopRequireDefault(require("ip-anonymize"));
var _internalPluginMetrics = require("@webex/internal-plugin-metrics");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _constants = require("../constants");
var _browserDetection = _interopRequireDefault(require("../common/browser-detection"));
var _config = require("./config");
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

// @ts-ignore

// @ts-ignore

var _BrowserDetection = (0, _browserDetection.default)(),
  getOSName = _BrowserDetection.getOSName,
  getOSVersion = _BrowserDetection.getOSVersion,
  getBrowserName = _BrowserDetection.getBrowserName,
  getBrowserVersion = _BrowserDetection.getBrowserVersion;

// Apply a CIDR /28 format to the IPV4 and /96 to the IPV6 addresses
// For reference : https://en.wikipedia.org/wiki/Classless_Inter-Domain_Routing
var anonymizeIPAddress = function anonymizeIPAddress(localIp) {
  return (0, _ipAnonymize.default)(localIp, 28, 96);
};
var triggerTimers = function triggerTimers(_ref) {
  var event = _ref.event,
    meeting = _ref.meeting,
    data = _ref.data;
  switch (event) {
    case _config.eventType.CALL_INITIATED:
      meeting.setStartCallInitiateJoinReq();
      break;
    case _config.eventType.LOCUS_JOIN_REQUEST:
      meeting.setEndCallInitiateJoinReq();
      meeting.setStartJoinReqResp();
      break;
    case _config.eventType.LOCUS_JOIN_RESPONSE:
      meeting.setEndJoinReqResp();
      meeting.setStartSetupDelay(_config.mediaType.AUDIO);
      meeting.setStartSetupDelay(_config.mediaType.VIDEO);
      meeting.setStartSendingMediaDelay(_config.mediaType.AUDIO);
      meeting.setStartSendingMediaDelay(_config.mediaType.VIDEO);
      break;
    case _config.eventType.RECEIVING_MEDIA_START:
      meeting.setEndSetupDelay(data.mediaType);
      break;
    case _config.eventType.SENDING_MEDIA_START:
      meeting.setEndSendingMediaDelay(data.mediaType);
      break;
    case _config.eventType.LOCAL_SDP_GENERATED:
      meeting.setStartLocalSDPGenRemoteSDPRecvDelay();
      break;
    case _config.eventType.REMOTE_SDP_RECEIVED:
      meeting.setEndLocalSDPGenRemoteSDPRecvDelay();
      break;
    default:
      break;
  }
};

/**
 * @description Metrics handles all the call metrics events
 * @export
 * @class Metrics
 */
var Metrics = /*#__PURE__*/function () {
  /**
   * Create Metrics Object
   * @constructor
   * @public
   * @memberof Meetings
   */
  function Metrics() {
    (0, _classCallCheck2.default)(this, Metrics);
    (0, _defineProperty2.default)(this, "_events", void 0);
    (0, _defineProperty2.default)(this, "keys", void 0);
    (0, _defineProperty2.default)(this, "meetingCollection", void 0);
    (0, _defineProperty2.default)(this, "webex", void 0);
    if (!Metrics.instance) {
      /**
       * @instance
       * @type {Array}
       * @private
       * @memberof Metrics
       */
      this._events = [];
      /**
       * @instance
       * @type {MeetingCollection}
       * @private
       * @memberof Metrics
       */
      this.meetingCollection = null;
      /**
       * @instance
       * @type {MeetingCollection}
       * @private
       * @memberof Metrics
       */
      this.keys = (0, _values.default)(_config.eventType);
      /**
       * @instance
       * @type {Metrics}
       * @private
       * @memberof Metrics
       */
      Metrics.instance = this;
    }

    // eslint-disable-next-line no-constructor-return
    return Metrics.instance;
  }

  /**
   * Initializes the Metrics singleton with a meeting Collection.
   *
   * @param {Object} meetingCollection meetings object
   * @param {Object} webex  webex SDK object
   *
   * @returns {void}
   */
  (0, _createClass2.default)(Metrics, [{
    key: "initialSetup",
    value: function initialSetup(meetingCollection, webex) {
      this.meetingCollection = meetingCollection;
      this.webex = webex;
    }

    /**
     * poste Meeting event metrics
     * @param {object} options {meetingId/meeting} as a json object
     * @param {Meeting} options.meeting Meeting object
     * @param {String} options.meetingId
     * @param {object} options.data
     * @param {object} options.event
     * @returns {object} null
     */
  }, {
    key: "postEvent",
    value: function postEvent(options) {
      var meetingId = options.meetingId,
        _options$data = options.data,
        data = _options$data === void 0 ? {} : _options$data,
        event = options.event;
      var meeting = options.meeting;
      if (this.keys.indexOf(event) === -1) {
        _loggerProxy.default.logger.error("Metrics:index#postEvent --> Event ".concat(event, " doesn't exist in dictionary"));
      }
      if (!meeting && meetingId) {
        meeting = this.meetingCollection.get(meetingId);
        options.meeting = meeting;
      }
      if (meeting) {
        triggerTimers(options);
        if (!meeting.callEvents) {
          meeting.callEvents = [];
        }
        if (event === _config.eventType.MEDIA_QUALITY) {
          data.event = event;
          meeting.sendMediaQualityAnalyzerMetrics(data);
        } else {
          meeting.callEvents.push(event);
          data.event = event;
          meeting.sendCallAnalyzerMetrics(data);
        }
      } else {
        _loggerProxy.default.logger.info("Metrics:index#postEvent --> Event received for meetingId:".concat(meetingId, ", but meeting not found in collection."));
      }
    }

    /**
     *  Docs for Call analyzer metrics
     *   https://sqbu-github.cisco.com/WebExSquared/call-analyzer/wiki
     *   https://sqbu-github.cisco.com/WebExSquared/event-dictionary/blob/master/diagnostic-events.raml
     */

    // eslint-disable-next-line @typescript-eslint/no-shadow
  }, {
    key: "initPayload",
    value: function initPayload(eventType, identifiers, options) {
      var _this$webex$meetings$, _this$webex$meetings$2;
      var payload = {
        eventId: _uuid.default.v4(),
        version: 1,
        origin: {
          name: 'endpoint',
          networkType: 'unknown',
          userAgent: this.userAgentToString(),
          clientInfo: {
            clientType: options.clientType,
            clientVersion: "".concat(_config.CLIENT_NAME, "/").concat(this.webex.version),
            localNetworkPrefix: anonymizeIPAddress((_this$webex$meetings$ = this.webex.meetings.geoHintInfo) === null || _this$webex$meetings$ === void 0 ? void 0 : _this$webex$meetings$.clientAddress),
            osVersion: getOSVersion() || 'unknown',
            subClientType: options.subClientType,
            os: (0, _internalPluginMetrics.getOSNameInternal)(),
            browser: getBrowserName(),
            browserVersion: getBrowserVersion()
          }
        },
        originTime: {
          triggered: new Date().toISOString()
        },
        senderCountryCode: (_this$webex$meetings$2 = this.webex.meetings.geoHintInfo) === null || _this$webex$meetings$2 === void 0 ? void 0 : _this$webex$meetings$2.countryCode,
        event: {
          name: eventType,
          canProceed: true,
          identifiers: identifiers,
          eventData: {
            webClientDomain: _window.default.location.hostname
          }
        }
      };

      // TODO: more options should be checked and some of them should be mandatory in certain conditions
      if (options) {
        if (Object.prototype.hasOwnProperty.call(options, 'canProceed')) {
          payload.event.canProceed = options.canProceed;
        }
        if (options.errors) {
          payload.event.errors = options.errors;
        }
        if (options.mediaType) {
          payload.event.mediaType = options.mediaType;
        }
        if (options.trigger) {
          payload.event.trigger = options.trigger;
        }
        if (options.pstnAudioType) {
          payload.event.pstnAudioType = options.pstnAudioType;
        }
        if (options.mediaCapabilities) {
          payload.event.mediaCapabilities = options.mediaCapabilities;
        }
        if (options.recoveredBy) {
          payload.event.recoveredBy = options.recoveredBy;
        }
        if (options.joinTimes) {
          payload.event.joinTimes = options.joinTimes;
        }
        if (options.isRoapCallEnabled) {
          payload.event.isRoapCallEnabled = options.isRoapCallEnabled;
        }
      }
      return payload;
    }

    /**
     * get the payload specific for a media quality event through call analyzer
     * @param {String} eventType the event name
     * @param {Object} identifiers contains the identifiers needed for CA
     * @param {String} identifiers.correlationId
     * @param {String} identifiers.locusUrl
     * @param {String} identifiers.locusId
     * @param {Object} options
     * @param {Object} options.intervalData
     * @param {String} options.clientType
     * @returns {Object}
     * @public
     * @memberof Metrics
     */
  }, {
    key: "initMediaPayload",
    value: function initMediaPayload(
    // eslint-disable-next-line @typescript-eslint/no-shadow
    eventType, identifiers) {
      var _this$webex$meetings$3, _this$webex$meetings$4;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var audioSetupDelay = options.audioSetupDelay,
        videoSetupDelay = options.videoSetupDelay,
        joinTimes = options.joinTimes;
      var payload = {
        eventId: _uuid.default.v4(),
        version: 1,
        origin: {
          audioSetupDelay: audioSetupDelay,
          videoSetupDelay: videoSetupDelay,
          name: 'endpoint',
          networkType: options.networkType || _config.UNKNOWN,
          userAgent: this.userAgentToString(),
          clientInfo: {
            clientType: options.clientType,
            // TODO: Only clientType: 'TEAMS_CLIENT' is whitelisted
            clientVersion: "".concat(_config.CLIENT_NAME, "/").concat(this.webex.version),
            localNetworkPrefix: anonymizeIPAddress((_this$webex$meetings$3 = this.webex.meetings.geoHintInfo) === null || _this$webex$meetings$3 === void 0 ? void 0 : _this$webex$meetings$3.clientAddress),
            os: (0, _internalPluginMetrics.getOSNameInternal)(),
            osVersion: getOSVersion() || _config.UNKNOWN,
            subClientType: options.subClientType,
            browser: getBrowserName(),
            browserVersion: getBrowserVersion()
          }
        },
        originTime: {
          triggered: new Date().toISOString()
        },
        senderCountryCode: (_this$webex$meetings$4 = this.webex.meetings.geoHintInfo) === null || _this$webex$meetings$4 === void 0 ? void 0 : _this$webex$meetings$4.countryCode,
        event: {
          name: eventType,
          canProceed: true,
          identifiers: identifiers,
          intervals: [options.intervalData],
          joinTimes: joinTimes,
          eventData: {
            webClientDomain: _window.default.location.hostname
          },
          sourceMetadata: {
            applicationSoftwareType: _config.CLIENT_NAME,
            applicationSoftwareVersion: this.webex.version,
            mediaEngineSoftwareType: getBrowserName() || 'browser',
            mediaEngineSoftwareVersion: getOSVersion() || _config.UNKNOWN,
            startTime: new Date().toISOString()
          }
        }
      };
      return payload;
    }

    /**
     * This function Parses a Locus error and returns a diagnostic event payload.
     * It should keep updating from:
     * https://sqbu-github.cisco.com/WebExSquared/spark-client-framework/blob/master/spark-client-framework/Adapters/TelephonyAdapter/TelephonyAdapter.cpp#L920
     *
     * @param {Object} err the error Object from Locus response
     * @param {boolean} showToUser true if a toast is shown to user
     * @returns {{showToUser: boolean, category: string, errorDescription: string,
     *  errorCode: number, errorData: *, fatal: boolean, name: string}}
     */
  }, {
    key: "parseLocusError",
    value: function parseLocusError(err, showToUser) {
      var errorCode;
      if (err && err.statusCode && err.statusCode >= 500) {
        errorCode = 1003;
      } else if (err && err.body && err.body.errorCode) {
        // locus error codes: https://sqbu-github.cisco.com/WebExSquared/locus/blob/master/server/src/main/resources/locus-error-codes.properties
        switch (_config.errorCodes[err.body.errorCode]) {
          case _constants.MEETING_ERRORS.FREE_USER_MAX_PARTICIPANTS_EXCEEDED:
            errorCode = 3007;
            break;
          case _constants.MEETING_ERRORS.PAID_USER_MAX_PARTICIPANTS_EXCEEDED:
          case _constants.MEETING_ERRORS.SERVICE_MAX_PARTICIPANTS_EXCEEDED:
            errorCode = 3002;
            break;
          case _constants.MEETING_ERRORS.INACTIVE:
            errorCode = 4001;
            break;
          case _constants.MEETING_ERRORS.EXCEEDED_MAX_JOINED_PARTICIPANTS:
          case _constants.MEETING_ERRORS.EXCEEDED_SERVICE_MAX_PARTICIPANTS:
            errorCode = 3001;
            break;
          case _constants.MEETING_ERRORS.MEETING_IS_LOCKED:
            errorCode = 4002;
            break;
          case _constants.MEETING_ERRORS.MEETING_IS_TERMINATING:
            errorCode = 4003;
            break;
          case _constants.MEETING_ERRORS.MEETING_REQUIRE_MODERATOR_PIN_INTENT:
            errorCode = 4004;
            break;
          case _constants.MEETING_ERRORS.MEETING_REQUIRE_MODERATOR_PIN:
            errorCode = 4005;
            break;
          case _constants.MEETING_ERRORS.MEETING_REQUIRE_MODERATOR_ROLE:
            errorCode = 4006;
            break;
          case _constants.MEETING_ERRORS.JOIN_RESTRICTED_USER:
          case _constants.MEETING_ERRORS.GET_RESTRICTED_USER:
          case _constants.MEETING_ERRORS.CREATE_MEDIA_RESTRICTED_USER:
            errorCode = 3005;
            break;
          case _constants.MEETING_ERRORS.JOIN_RESTRICTED_USER_NOT_IN_ROOM:
            errorCode = 4007;
            break;
          case _constants.MEETING_ERRORS.MEETING_NOT_FOUND:
            errorCode = 4011;
            break;
          case _constants.MEETING_ERRORS.NOT_WEBEX_SITE:
            errorCode = 4012;
            break;
          case _constants.MEETING_ERRORS.INVALID_JOIN_TIME:
            errorCode = 4013;
            break;
          case _constants.MEETING_ERRORS.PHONE_NUMBER_NOT_A_NUMBER:
            errorCode = 4016;
            break;
          case _constants.MEETING_ERRORS.PHONE_NUMBER_TOO_LONG:
            errorCode = 4017;
            break;
          case _constants.MEETING_ERRORS.INVALID_DIALABLE_KEY:
            errorCode = 4018;
            break;
          case _constants.MEETING_ERRORS.ONE_ON_ONE_TO_SELF_NOT_ALLOWED:
            errorCode = 4019;
            break;
          case _constants.MEETING_ERRORS.REMOVED_PARTICIPANT:
            errorCode = 4020;
            break;
          case _constants.MEETING_ERRORS.MEETING_LINK_NOT_FOUND:
            errorCode = 4021;
            break;
          case _constants.MEETING_ERRORS.PHONE_NUMBER_TOO_SHORT_AFTER_IDD:
            errorCode = 4022;
            break;
          case _constants.MEETING_ERRORS.INVALID_INVITEE_ADDRESS:
            errorCode = 4023;
            break;
          case _constants.MEETING_ERRORS.PMR_ACCOUNT_LOCKED:
            errorCode = 4024;
            break;
          case _constants.MEETING_ERRORS.RESOURCE_GUEST_FORBIDDEN:
            errorCode = 4025;
            break;
          case _constants.MEETING_ERRORS.PMR_ACCOUNT_SUSPENDED:
            errorCode = 4026;
            break;
          case _constants.MEETING_ERRORS.EMPTY_PHONE_NUMBER_OR_COUNTRY_CODE:
            errorCode = 4027;
            break;
          case _constants.MEETING_ERRORS.INVALID_SINCE_OR_SEQUENCE_HASH_IN_REQUEST:
            errorCode = 1006;
            break;
          case _constants.MEETING_ERRORS.CONVERSATION_NOT_FOUND:
            errorCode = 4028;
            break;
          case _constants.MEETING_ERRORS.RECORDING_CONTROL_NOT_SUPPORTED:
          case _constants.MEETING_ERRORS.RECORDING_NOT_STARTED:
          case _constants.MEETING_ERRORS.RECORDING_NOT_ENABLED:
            errorCode = 4029;
            break;
          default:
            errorCode = 4008;
        }
      } else {
        errorCode = 4008;
      }
      return this.generateErrorPayload(errorCode, showToUser, _config.error.name.LOCUS_RESPONSE, err);
    }
  }, {
    key: "generateErrorPayload",
    value: function generateErrorPayload(errorCode, shownToUser, name, err) {
      if (_config.error.errors[errorCode]) {
        var errorPayload = {
          shownToUser: shownToUser || false,
          category: _config.error.errors[errorCode][2],
          errorDescription: _config.error.errors[errorCode][0],
          errorCode: errorCode,
          fatal: !(0, _includes2.default)(_config.error.notFatalErrorList, errorCode),
          name: name || _config.error.name.OTHER
        };
        if (err && err.body) {
          errorPayload.errorData = err.body;
        }
        if (err && err.statusCode) {
          errorPayload.httpCode = err.statusCode;
        }
        return errorPayload;
      }
      return null;
    }

    /**
     * Returns a formated string of the user agent.
     *
     * @returns {string} formatted user agent information
     */
  }, {
    key: "userAgentToString",
    value: function userAgentToString() {
      var _this$webex$meetings, _this$webex$meetings$5;
      var userAgentOption;
      var browserInfo;
      var clientInfo = _util.default.format('client=%s', "".concat((_this$webex$meetings = this.webex.meetings) === null || _this$webex$meetings === void 0 ? void 0 : (_this$webex$meetings$5 = _this$webex$meetings.metrics) === null || _this$webex$meetings$5 === void 0 ? void 0 : _this$webex$meetings$5.clientName));
      if (['chrome', 'firefox', 'msie', 'msedge', 'safari'].indexOf(getBrowserName().toLowerCase()) !== -1) {
        browserInfo = _util.default.format('browser=%s', "".concat(getBrowserName().toLowerCase(), "/").concat(getBrowserVersion().split('.')[0]));
      }
      var osInfo = _util.default.format('os=%s', "".concat(getOSName(), "/").concat(getOSVersion().split('.')[0]));
      if (browserInfo) {
        userAgentOption = "(".concat(browserInfo);
      }
      if (osInfo) {
        userAgentOption = userAgentOption ? "".concat(userAgentOption, "; ").concat(clientInfo, "; ").concat(osInfo) : "".concat(clientInfo, "; (").concat(osInfo);
      }
      if (userAgentOption) {
        userAgentOption += ')';
        return _util.default.format('webex-js-sdk/%s %s', "".concat(process.env.NODE_ENV, "-").concat(this.webex.version), userAgentOption);
      }
      return _util.default.format('webex-js-sdk/%s', "".concat(process.env.NODE_ENV, "-").concat(this.webex.version));
    }

    /**
     * Uploads given metric to the Metrics service as an Behavioral metric.
     * Metadata about the environment such as browser, OS, SDK and their versions
     * are automatically added when the metric is sent.
     *
     * The Metrics service will send an Behavioral metric to InfluxDB for
     * aggregation.
     * See https://confluence-eng-gpk2.cisco.com/conf/display/WBXT/Getting+started+with+Metrics+Service.
     *
     * @param {string} metricName  Name of the metric (measurement) to send
     * @param {Object} metricFields  Key-valye pairs of data or values about this metric
     * @param {Object} metricTags  Key-value pairs of metric metadata
     *
     * @returns {void}
     */
  }, {
    key: "sendBehavioralMetric",
    value: function sendBehavioralMetric(metricName) {
      var metricFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var metricTags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.webex.internal.metrics.submitClientMetrics(metricName, {
        type: this.webex.config.metrics.type,
        fields: metricFields,
        tags: metricTags
      });
    }
  }]);
  return Metrics;
}(); // Export Metrics singleton ---------------------------------------------------
(0, _defineProperty2.default)(Metrics, "instance", void 0);
var instance = new Metrics();
var _default = instance;
exports.default = _default;
//# sourceMappingURL=index.js.map
